import apiClient from '@/services/apiClient'

export default {
  async getVesprocDefaults() {
    const response = await apiClient.get('/api/supplier/app-status/vesproc-defaults')
    return response.data || []
  },
  async getSelection(groupKey) {
    const response = await apiClient.post('/api/supplier/app-status/selection', null, {
      params: { groupKey }
    })
    const raw = response?.data
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw)
      } catch (e) {
        return []
      }
    }
    return raw || []
  },
  async getVesprocByTenant(tenantId) {
    if (!tenantId) return []
    const response = await apiClient.get(`/api/supplier/app-status/vesproc-by-tenant/${tenantId}`)
    return response.data || []
  },
  async getRelatedStatusMappings() {
    // Returns array: [{ nozzleStatusId: string, vesprocStatusId: string }]
    const response = await apiClient.get('/api/supplier/app-status/related-status-mappings')
    return response.data || []
  },
  async saveStatusMapping(payload) {
    // payload: { nozzleStatusId: string, vesprocStatusId: string }
    const response = await apiClient.put('/api/supplier/app-status/related-status', payload)
    return response.data
  },
  async searchMappings(search = {}) {
    // POST search to get existing mappings
    // backend seems to ignore filters; send as provided
    const response = await apiClient.post('/api/supplier/app-statues-vs-tenant/search', search)
    return response.data || { items: [], totalCount: 0 }
  }
}


